/* Product card behaviour: mobile image cycle + quick add.
   Moved out of snippets/product-card-v2.liquid 2026-07-27 — it was inlined
   once per card (~11.7 KB x 36 cards = ~413 KB of duplicate HTML).
   Safe to defer: cycle waits for DOMContentLoaded + MutationObserver,
   quick-add uses document-level click delegation. */
(function(){
  if (window.__cardCycleInit) return;
  window.__cardCycleInit = true;

  /* 08-18: cards used to share ONE global timer, so every visible card flipped its photo
     at the exact same millisecond forever — looked robotic/synchronized on a full grid
     (Maria: "very unnatural... looks awful"). Fix: each card gets its own randomized
     __nextFlip timestamp (staggered on first becoming visible, re-jittered a bit each
     cycle after), checked by a more frequent shared tick — one timer still, but cards
     drift out of sync with each other like real content would. */
  function withJitter(baseMs, jitterMs){ return Date.now() + baseMs + Math.random() * jitterMs; }

  var visible = new Set();
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) {
        if (!en.target.__nextFlip) en.target.__nextFlip = withJitter(700, 3300);
        visible.add(en.target);
      } else {
        visible.delete(en.target);
      }
    });
  }, { threshold: 0.35 }) : null;

  function scan(){
    document.querySelectorAll('[data-card-cycle]').forEach(function(w){
      if (w.__cycleReady) return;
      var alts = w.querySelectorAll('[data-cycle-img]');
      if (alts.length === 0) { w.__cycleReady = true; return; }
      w.__cycleReady = true;
      w.__ci = 0;
      if (io) io.observe(w); else { w.__nextFlip = withJitter(900, 2400); visible.add(w); }
    });
  }

  function render(w, idx){
    var alts = w.querySelectorAll('[data-cycle-img]');
    if (alts.length === 0) return;
    var total = alts.length + 1;
    w.__ci = ((idx % total) + total) % total;
    alts.forEach(function(img, i){ img.classList.toggle('is-shown', i === w.__ci - 1); });
    var dots = w.querySelectorAll('.product-card__cycle-dot');
    dots.forEach(function(d, i){ d.classList.toggle('is-on', i === w.__ci); });
  }
  window.__cardCycleRender = render;

  function tick(){
    var now = Date.now();
    visible.forEach(function(w){
      if (!w.__nextFlip) { w.__nextFlip = withJitter(0, 3300); return; }
      if (now >= w.__nextFlip) {
        render(w, (w.__ci || 0) + 1);
        w.__nextFlip = withJitter(2400, 1200);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    scan();
    /* 08-17: reduced-motion gate removed (Maria). It silently disabled the auto-cycle on any
       device with OS-level Reduce Motion on, which read as "carousel is broken" — the cycle is
       a gentle 0.55s opacity crossfade, not movement, so the vestibular-motion risk the gate
       guarded against doesn't really apply here. Dots and swipe remain available regardless. */
    /* 08-18: tick runs every 400ms now (was 3000ms) — it's just a due-time check per card, not
       the flip interval itself, so this stays cheap while letting each card's own ~3s cycle
       fire close to on-time instead of all cards syncing to one shared 3s beat. */
    setInterval(function(){ if (document.visibilityState === 'visible' && visible.size) tick(); }, 400);
    var scanT; var mo = new MutationObserver(function(){ clearTimeout(scanT); scanT = setTimeout(scan, 200); });
    mo.observe(document.body, { childList: true, subtree: true });
  });

  /* 08-11: dots had no click handler, so a tap meant to cycle photos fell through to the
     card's <a> and navigated to the PDP instead — an immediate bounce-back. Dots stay <span>
     (not <button>) because they sit inside the anchor; a real button nested in an <a> is
     invalid HTML and browsers reparent it out, breaking the overlay positioning — same reason
     the wishlist heart above is a sibling of the link, not nested in it. role="button" +
     tabindex give equivalent semantics without the reparenting problem. */
  function activateDot(dot){
    var w = dot.closest('[data-card-cycle]');
    if (!w) return;
    var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
    if (isNaN(idx)) return;
    render(w, idx);
  }
  document.addEventListener('click', function(e){
    var dot = e.target.closest('.product-card__cycle-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    activateDot(dot);
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var dot = e.target.closest && e.target.closest('.product-card__cycle-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    activateDot(dot);
  });
})();

/* Quick-add JS — inits once per page via guard flag */
(function(){
  if (window.__quickAddInit) return;
  window.__quickAddInit = true;

  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function showToast(msg, ok) {
    var t = document.getElementById('qa-toast');
    if (!t) { t = document.createElement('div'); t.id = 'qa-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.className = 'qa-toast qa-toast--' + (ok ? 'ok' : 'err') + ' qa-toast--show';
    clearTimeout(t._timer);
    t._timer = setTimeout(function(){ t.classList.remove('qa-toast--show'); }, 2800);
  }

  function updateFloatingCart(cart) {
    var el = document.querySelector('[data-floating-cart]');
    if (!el) return;
    var cnt = el.querySelector('[data-floating-count]');
    var tot = el.querySelector('[data-floating-total]');
    if (cart.item_count > 0) {
      el.style.display = '';
      if (cnt) cnt.textContent = cart.item_count;
      if (tot) tot.textContent = fmtMoney(cart.total_price);
    }
  }

  /* 10-19 (Maria approved "All of it now"): quick add on cards used to add silently on phones
     (only a 2.8s toast + the tiny bottom-bar badge). Now it opens the cart drawer, the same way
     product pages do, and tells the drawer about the new cart so it renders without a refetch.
     Falls back to the toast if the drawer isn't on the page. */
  function fgOpenDrawer(cart) {
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (x) {}
    if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); return true; }
    return false;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var label = btn.querySelector('.product-card__atc-label');
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function() {
      if (label) label.textContent = '✓ Added!';
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart) {
      updateFloatingCart(cart);
      if (!fgOpenDrawer(cart)) showToast('Added to cart!', true);
      setTimeout(function() { btn.disabled = false; if (label) label.textContent = 'Add to Cart'; }, 1800);
    })
    .catch(function() {
      btn.disabled = false;
      if (label) label.textContent = 'Add to Cart';
      showToast('Could not add — please try again.', false);
    });
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-pick]');
    if (!btn) return;
    openPicker(btn.getAttribute('data-product-url'), btn);
  });

  function openPicker(productUrl, triggerBtn) {
    var existing = document.getElementById('qa-picker');
    if (existing) existing.remove();
    var sheet = document.createElement('div');
    sheet.id = 'qa-picker';
    sheet.innerHTML = '<div class="qa-picker__overlay" id="qa-overlay"></div><div class="qa-picker__drawer" role="dialog" aria-label="Choose options"><div class="qa-picker__inner"><div class="qa-picker__loading">Loading…</div></div></div>';
    document.body.appendChild(sheet);
    document.body.style.overflow = 'hidden';
    document.getElementById('qa-overlay').addEventListener('click', closePicker);
    requestAnimationFrame(function() { sheet.classList.add('qa-picker--open'); });
    fetch(productUrl + '.js')
    .then(function(r){ return r.json(); })
    .then(function(p) {
      var inner = sheet.querySelector('.qa-picker__inner');
      var imgSrc = p.featured_image || '';
      var imgTag = imgSrc ? '<img src="' + imgSrc + '" alt="" class="qa-picker__img">' : '';
      var optionsHtml = p.options.map(function(opt, oi) {
        return '<div class="qa-picker__option"><p class="qa-picker__opt-name">' + opt.name + '</p><div class="qa-picker__opt-btns">' +
          opt.values.map(function(v) {
            return '<button type="button" class="qa-opt-btn" data-opt-index="' + oi + '" data-opt-value="' + v.replace(/"/g,'&quot;') + '">' + v + '</button>';
          }).join('') + '</div></div>';
      }).join('');
      inner.innerHTML = [
        '<button type="button" class="qa-picker__close" id="qa-close" aria-label="Close">&times;</button>',
        imgTag,
        '<p class="qa-picker__title">' + p.title + '</p>',
        '<p class="qa-picker__price" id="qa-price"></p>',
        optionsHtml,
        '<button type="button" class="qa-picker__add" id="qa-add" disabled>Select options</button>',
        '<p class="qa-picker__err" id="qa-err"></p>'
      ].join('');
      document.getElementById('qa-close').addEventListener('click', closePicker);
      var selected = {};
      inner.addEventListener('click', function(e2) {
        var ob = e2.target.closest('.qa-opt-btn');
        if (!ob) return;
        var oi = parseInt(ob.getAttribute('data-opt-index'), 10);
        inner.querySelectorAll('.qa-opt-btn[data-opt-index="' + oi + '"]').forEach(function(b){ b.classList.remove('qa-opt-btn--active'); });
        ob.classList.add('qa-opt-btn--active');
        selected[oi] = ob.getAttribute('data-opt-value');
        var v = p.variants.find(function(v){ return v.options.every(function(o,i){ return selected[i] === o; }); }) || null;
        var addBtn = document.getElementById('qa-add');
        var priceEl = document.getElementById('qa-price');
        if (v) {
          priceEl.textContent = fmtMoney(v.price);
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
          addBtn.setAttribute('data-variant-id', v.id);
        } else {
          addBtn.disabled = true; addBtn.textContent = 'Select options'; addBtn.removeAttribute('data-variant-id');
        }
      });
      document.getElementById('qa-add').addEventListener('click', function() {
        var addBtn = document.getElementById('qa-add');
        var varId = addBtn.getAttribute('data-variant-id');
        if (!varId) return;
        addBtn.disabled = true; addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(varId, 10), quantity: 1 })
        })
        .then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
        .then(function(){
          addBtn.textContent = '✓ Added!';
          return fetch('/cart.js').then(function(r){ return r.json(); });
        })
        .then(function(cart){ updateFloatingCart(cart); closePicker(); if (!fgOpenDrawer(cart)) showToast('Added to cart!', true); })
        .catch(function(){
          addBtn.disabled = false; addBtn.textContent = 'Add to Cart';
          var err = document.getElementById('qa-err'); if (err) err.textContent = 'Could not add — please try again.';
        });
      });
    })
    .catch(function(){
      sheet.querySelector('.qa-picker__inner').innerHTML = '<button class="qa-picker__close" id="qa-close">&times;</button><p style="padding:24px">Could not load product. <a href="' + productUrl + '">View product page</a></p>';
      document.getElementById('qa-close').addEventListener('click', closePicker);
    });
  }

  function closePicker() {
    var sheet = document.getElementById('qa-picker');
    if (!sheet) return;
    sheet.classList.remove('qa-picker--open');
    document.body.style.overflow = '';
    setTimeout(function(){ if (sheet.parentNode) sheet.remove(); }, 320);
  }

  if (!document.getElementById('qa-styles')) {
    var s = document.createElement('style');
    s.id = 'qa-styles';
    s.textContent = [
      '.qa-toast{position:fixed;bottom:96px;left:50%;transform:translateX(-50%) translateY(20px);background:#1a1a1a;color:#fff;padding:12px 22px;border-radius:999px;font-size:14px;font-weight:500;opacity:0;transition:opacity .25s,transform .25s;pointer-events:none;z-index:9999;white-space:nowrap;}',
      '.qa-toast--ok{background:#1f6b3a;}.qa-toast--err{background:#c0392b;}',
      '.qa-toast--show{opacity:1;transform:translateX(-50%) translateY(0);}',
      '#qa-picker{position:fixed;inset:0;z-index:500;pointer-events:none;}',
      '#qa-picker.qa-picker--open{pointer-events:auto;}',
      '.qa-picker__overlay{position:absolute;inset:0;background:rgba(0,0,0,0);transition:background .3s;}',
      '.qa-picker--open .qa-picker__overlay{background:rgba(0,0,0,.45);}',
      '.qa-picker__drawer{position:absolute;bottom:0;left:0;right:0;background:#fff;border-radius:18px 18px 0 0;max-height:88vh;overflow-y:auto;transform:translateY(100%);transition:transform .32s cubic-bezier(.4,0,.2,1);padding-bottom:env(safe-area-inset-bottom,16px);}',
      '.qa-picker--open .qa-picker__drawer{transform:translateY(0);}',
      '.qa-picker__inner{padding:20px 20px 32px;position:relative;}',
      '.qa-picker__close{position:absolute;top:14px;right:16px;background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#555;padding:4px 8px;}',
      '.qa-picker__img{width:80px;height:80px;object-fit:cover;border-radius:8px;margin-bottom:12px;}',
      '.qa-picker__title{font-size:16px;font-weight:600;color:#1a1a1a;margin:0 0 4px;line-height:1.3;}',
      '.qa-picker__price{font-size:18px;font-weight:700;color:#1a1a1a;margin:0 0 18px;}',
      '.qa-picker__option{margin-bottom:16px;}',
      '.qa-picker__opt-name{font-size:13px;font-weight:600;color:#555;text-transform:uppercase;letter-spacing:.08em;margin:0 0 8px;}',
      '.qa-picker__opt-btns{display:flex;flex-wrap:wrap;gap:8px;}',
      '.qa-opt-btn{padding:9px 18px;border:1.5px solid #ddd;border-radius:6px;background:#fff;font-size:14px;font-weight:500;color:#1a1a1a;cursor:pointer;transition:all .15s;}',
      '.qa-opt-btn:hover{border-color:#1a1a1a;}',
      '.qa-opt-btn--active{border-color:#1a1a1a;background:#1a1a1a;color:#fff;}',
      '.qa-picker__add{width:100%;margin-top:8px;padding:16px;background:#1a1a1a;color:#fff;border:none;border-radius:6px;font-size:15px;font-weight:600;cursor:pointer;transition:background .2s;}',
      '.qa-picker__add:disabled{background:#ccc;cursor:not-allowed;}',
      '.qa-picker__add:not(:disabled):hover{background:#333;}',
      '.qa-picker__err{color:#c0392b;font-size:13px;margin-top:8px;min-height:16px;}',
      '.qa-picker__loading{padding:32px;text-align:center;color:#888;}'
    ].join('');
    document.head.appendChild(s);
  }
})();

/* Touch-swipe between card images (07-31). Passive listeners; never blocks scroll. */
(function(){
  if (window.__cardSwipeInit) return;
  window.__cardSwipeInit = true;
  var sw = null, sx = 0, sy = 0;
  function stepCard(w, dir) {
    if (window.__cardCycleRender) window.__cardCycleRender(w, (w.__ci || 0) + dir);
  }
  document.addEventListener('touchstart', function(e){
    var w = e.target.closest ? e.target.closest('[data-card-cycle]') : null;
    if (!w || !w.querySelector('[data-cycle-img]')) { sw = null; return; }
    sw = w; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function(e){
    if (!sw || !e.changedTouches || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - sx;
    var dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 35 && Math.abs(dx) > 1.5 * Math.abs(dy)) stepCard(sw, dx < 0 ? 1 : -1);
    sw = null;
  }, { passive: true });
})();
